// extracted by mini-css-extract-plugin
export default {"medicalConsent":"_32d-xJM1HglZ_iUMycOmyQ"};